<template>
  <div id="resultado" class="">
    <section class="bannerprincipal">
      <div class="">
        <div class="row">
          <div class="col-12 col-md-12 offset-md-0 h-100">
            <div class="py-2"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="pt-5">
      <div class="pt-0">
        <div class="row">
          <div class="col-md-6 d-none d-md-flex">
            <img
              src="../assets/imgs/verano23/logo-verano-cinepolis.png"
              alt="Verano Cinépolis"
              class="img-fluid"
            />
          </div>

          <div class="col-12 col-md-6 fG pt-3">
            <div class="row">
              <div class="col-12 d-flex d-md-none py-5">
                &nbsp;
              </div>
              <div class="col-12 col-md-10 px-5">
                <div class="circuloblanco">
                  <span class="blanco fanta nombre fXG">{{
                    userProfile.nombre
                  }}</span>

                  <img
                    class="w100p"
                    src="../assets/imgs/verano23/estrella-verde.png"
                    alt="Verano con sabor a cinepolis"
                  />

                  <div class="blanco texto">
                    <span class="fXXXG morado fanta">{{ puntos }}</span>
                    <br>
                    <span class="fXG blanco fanta">PUNTOS</span>
                  </div>

                  <div class="row pb-3">
                    <div class="col-12 offset-0 col-lg-6 offset-lg-3 text-center">
                      <router-link
                        to="/mis-participaciones"
                        class="pointer d-inline-block align-items-center justify-content-center btnaction fanta fG ml-auto mr-auto"
                      >
                        Continuar
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-10 offset-lg-2 text-right">
                <img src="../assets/imgs/verano23/mnms4.png" alt="m&m" class="img-fluid d-block d-md-none">
                <img src="../assets/imgs/verano23/mnms2.png" alt="m&m" class="img-fluid d-none d-md-block">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import { ticketsCollection } from "@/firebase";
import AOS from "aos";
import { mapState } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: true,
      time: 0,
      time_txt: "",
      suma_puntos: 0,
      suma_time: 0,
      tickets2: [],
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      ahora: null,
      semana_corriente: "",
      multiplicador: 1,
      puntos: 0
    };
  },
  computed: {
    ...mapState(["userProfile", "tickets"]),
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });
    //let en_participacion = this.$store.dispatch('isParticipando')
    console.log({ userProfile: this.userProfile });
    //this.getTickets();
    this.getTickets2();
  },
  methods: {
    async getTickets2() {
      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .get();

      this.tickets3 = [];
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;
        this.tickets3.push(ticket);

        // if (ticket.cashi === true){
        //   this.multiplicador = 2;
        // }else{
        //   this.multiplicador = 1;
        // }
      });
      this.tickets3 = this.tickets3.sort(this.custom_sort);
      console.log({ tickets3: this.tickets3 });

      this.setResumen();
    },
    getTiempoFormato(time) {
      return this.secondsToHms(time);
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    async setResumen() {
      if (this.tickets3.length > 0) {
        this.ultimo_ticket = this.tickets3[this.tickets3.length - 1];
        
      }
      console.log({ ultimo: this.ultimo_ticket });
      console.log({ ultimo_id: this.ultimo_ticket.id });

      await this.getAhora();
      this.semana_corriente = this.getNumSemana(this.ahora);
      //console.log({tengoahora: this.ahora});

      let week = this.getSemana(this.ahora);
      let suma_puntos = 0;
      let suma_time = 0;
      this.tickets3.forEach((element) => {
        //console.log({ elem: element.created_on.seconds });
        let date = moment.unix(element.created_on.seconds).format("L");
        //console.log(date);
        //console.log(moment(date).week());
        let temp_week = moment(date).add(2, "days").week();
        if (week == temp_week) {
          suma_puntos = suma_puntos + parseInt(element.puntos);
          suma_time = suma_time + parseInt(element.time);
        }
      });

      console.log({ultimo_ticket_MNMS: this.ultimo_ticket.mnms})
      if(this.ultimo_ticket.mnms === true){
        this.multiplicador = 2;
      }

      this.puntos = this.ultimo_ticket.puntos * this.multiplicador;

      // if(this.userProfile.puntos_club_cinepolis != undefined){
      //   this.puntos += this.userProfile.puntos_club_cinepolis;
      // }

      // console.log({ multiplicador: this.tickets });
      console.log({ userProfile: this.userProfile });

      this.suma_puntos = suma_puntos;
      //alert(suma_time)
      this.suma_time = this.secondsToHms(suma_time);
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    getNumSemana(fecha) {
      let semana = parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
      if (semana == 0) semana = 1;
      return semana;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
